<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.statistics_manage')}}<span class="page-header-breadcrumb">></span>{{ $t('words.statistics_service_usage')}}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.statistics.service_usage_download_tip') }"><i class="icon icon-info-circle-line"></i></span></h3>
                    <div style="text-align: right;color: #868e96;width: 100%;padding: 10px;">{{ $t('paragraphs.statistics.service_usage_file_download_tip') }}</div><div class="page-header-action-group"><a class="btn" :href="getExportUrl"><i class="icon icon-download"></i>{{ $t('words.statistics_download') }}</a></div>
                </div>
                <div class="page-sub-header clearfix">
                    <div class="form-inline float-left">
                        <div class="control-group">
                            <label for="select_channel" class="sr-only">{{ $t('words.channel') }}</label>
                            <select id="select_channel" :placeholder="$t('words.channel')">
                                <!--<option value="">All Channels</option>-->
                                <!--<option :value="channel.id" v-for="channel in select.channels" :key="channel.id">{{ channel.title }}</option>-->
                            </select>
                        </div>
                        <div class="form-checkbox ml-2">
                            <input type="checkbox" v-model="includeTrashedChannel" id="includeTrashedChannel">
                            <label for="includeTrashedChannel">{{ $t('words.include_removed_channels')}}</label>
                        </div>
                    </div>
                    <div class="module-action-group float-right">
                        <div class="btn-group btn-group__date">
                            <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d')">{{ $t('words.period_today') }}</button>
                            <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d')">{{ $t('words.period_3d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='7d')}" @click="changePeriod('7d')">{{ $t('words.period_7d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='30d')}" @click="changePeriod('30d')">{{ $t('words.period_30d') }}</button>
                        </div>
                        <div class="input-group input-group-date input-daterange" id="date-range">
                            <div class="input-group">
                                <vue-date-picker
                                    v-model="rangeDay"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    range
                                    placeholder="Select date range"
                                    :disabled-date="notRangedDate"
                                >
                                </vue-date-picker>
                            </div>
                            <div class="input-group-append">
                                <button type="button" :class="{'btn': true, 'btn-icon': true, 'active': (period === 'custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="module" v-if="loadSummary">
                <div class="module-body">
                    <ul class="dashboard dashboard__4">
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.live_count')}}</h5>
                            <p class="dashboard-desc">{{ serviceUsageSummary.liveCount }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.watch_time')}}</h5>
                            <p class="dashboard-desc">{{ serviceUsageSummary.watch_time }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.broadcast_interval')}}</h5>
                            <p class="dashboard-desc">{{ serviceUsageSummary.broadcastInterval }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.syndication_time') }}</h5>
                            <p class="dashboard-desc">{{ serviceUsageSummary.syndication_interval }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.recording_file_created_volume')}}(GiB)</h5>
                            <p class="dashboard-desc">{{ serviceUsageSummary.fileSize }}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <nav aria-label="Page navigation" class="ml-auto">
                        <ul class="pagination">
                            <li class="page-info">
                                {{ $t('paragraphs.page_navigation', { total: serviceUsages.meta.total, from: ((serviceUsages.meta.current_page - 1) * serviceUsages.meta.per_page + 1), to: (serviceUsages.meta.current_page === serviceUsages.meta.last_page ? serviceUsages.meta.total : serviceUsages.meta.per_page * serviceUsages.meta.current_page )}) }}
                            </li>
                            <li :class="{'page-item': true, disabled: !serviceUsages.links.prev }">
                                <button class="page-link" aria-label="Previous" @click="loadServiceUsages(serviceUsages.links.prev)" v-if="serviceUsages.links.prev">
                                    <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                </button>
                                <button class="page-link" aria-label="Previous" v-else>
                                    <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                </button>
                            </li>
                            <li :class="{'page-item': true, disabled: !serviceUsages.links.next }">
                                <button class="page-link" aria-label="Next" @click="loadServiceUsages(serviceUsages.links.next)" v-if="serviceUsages.links.next">
                                    <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                                </button>
                                <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                    <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('pagination.next') }}</span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="module-body module-body-table table--responsive">
                    <table class="table table-wide">
                        <thead>
                        <tr>
                            <th>
                                <span class="btn-order" @click="changeOrder('channel_name_desc')">
                                    {{ $t('words.channel_name') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'channel_name_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'channel_name_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('live_name_desc')">
                                    {{ $t('words.live_name') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'live_name_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'live_name_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('start_time_desc')">
                                    {{ $t('words.start_time') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'start_time_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'start_time_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('end_time_desc')">
                                    {{ $t('words.end_time') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'end_time_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'end_time_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>
                                {{ $t('words.watch_time') }}
                            </th>
                            <th>
                                <span class="btn-order" @click="changeOrder('broadcast_interval_desc')">
                                    {{ $t('words.broadcast_interval') }}
                                    <span class="icon-triangle-wrap">
                                        <i class="icon icon-triangle-up" :class="{'active':list_conditions.order === 'broadcast_interval_asc'}"></i>
                                        <i class="icon icon-triangle-down" :class="{'active':list_conditions.order === 'broadcast_interval_desc'}"></i>
                                    </span>
                                </span>
                            </th>
                            <th>{{ $t('words.syndication_time') }}</th>
                            <th>{{ $t('words.max_acc_user') }}</th>
                            <th>{{ $t('words.total_acc_user') }}</th>
                            <th>{{ $t('words.max_cur_user') }}</th>
                            <th>{{ $t('words.total_visit_count') }}</th>
                            <th class="text-right">{{ $t('words.recording_file_created_volume')}}(GiB)</th>
                        </tr>
                        </thead>
                        <tbody v-if="serviceUsages.load && (serviceUsages.meta.total !== 0)">
                        <tr v-for="(serviceUsage, index) in serviceUsages.data" :key="index">
                            <td><span class="list__channel__name is-wide" v-tooltip="{ content: serviceUsage.channel_title, html:false }">{{ serviceUsage.channel_title }}</span></td>
                            <td><span class="list__channel__name is-wide" v-tooltip="{ content: serviceUsage.broadcast_title, html:false }">{{ serviceUsage.broadcast_title }}</span></td>
                            <td class="td__date">{{ serviceUsage.started_at | renderDateTime }}</td>
                            <td class="td__date">{{ serviceUsage.ended_at | renderDateTime }}</td>
                            <td class="td__date">{{ serviceUsage.watch_time }}</td>
                            <td class="td__date">{{ serviceUsage.interval }}</td>
                            <td class="td__date">{{ serviceUsage.syndication_time }}</td>
                            <td class="td__date">{{ serviceUsage.sum_user }}</td>
                            <td class="td__date">{{ serviceUsage.total_acc_user }}</td>
                            <td class="td__date">{{ serviceUsage.max_cur_user }}</td>
                            <td class="td__date">{{ serviceUsage.total_count }}</td>
                            <td class="text-right td__minimize">{{ serviceUsage.file_size }}</td>
                        </tr>
                        </tbody>
                        <tbody v-else-if="serviceUsages.load">
                        <tr>
                            <td colspan="12" class="td__message">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="12" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';
import 'selectize';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        VueDatePicker,
    },
    data() {
        return {
            selectedChannel: '',
            selectize_channels: null,
            selectize_broadcasts: null,
            selectedBroadcast: '',
            includeTrashedChannel: false,
            channel: {},
            broadcast: {},
            list_conditions: {
                order: 'id_desc',
                trashed_order: 'id_desc',
                page: 1,
            },
            startDayLimit: '',
            endDayLimit: '',
            rangeDay: [],
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            period: '',
            serviceUsageSummary: {
                liveCount: 0,
                broadcastInterval: 0,
                fileSize: 0,
                watch_time: 0,
                syndication_interval: 0,
            },
            serviceUsages: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
            loadSummary: false,
        };
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            // this.loadChannel();
            this.initSelectableDate('1y');
            this.changePeriod('1d');
            this.loadSelectChannel();
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';

            this.loadServiceUsagesSummary();
            this.loadServiceUsages(this.serviceUsageApi);
        },
        loadChannel() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.channelApi).then((response) => {
                this.channel = response.data.data;
            });
        },
        loadSelectChannel() {
            const self = this;
            const selectizeObj = $('#select_channel').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.selectedChannel = value;
                    self.loadSummary = false;
                    self.loadServiceUsagesSummary();
                    self.loadServiceUsages(self.serviceUsageApi);
                },
                load(query, callback) {
                    this.clearOptions();

                    self.selectedChannel = '';
                    self.selectedBroadcast = '';

                    const uri = `/cms/${self.selectedServiceAccount.key}/select_channels?keyword=${query}&with_trashed=${self.includeTrashedChannel}`;

                    axios.get(uri).then((response) => {
                        response.data.data.unshift({ id: '', title: self.$t('words.all_channels') });
                        callback(response.data.data);
                    }).catch((error) => {
                        // self.$toasted.error('Failed to load channels');
                        // console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_channels') }]);
                    });
                },
            });

            this.selectize_channels = selectizeObj[0].selectize;
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.loadServiceUsagesSummary();
            this.loadServiceUsages(this.serviceUsageApi);
        },
        loadServiceUsagesSummary() {
            this.loadSummary = false;
            axios.get(this.serviceUsageSummaryApi).then((response) => {
                this.serviceUsageSummary.liveCount = response.data.summary.live_count;
                this.serviceUsageSummary.watch_time = response.data.summary.watch_time;
                this.serviceUsageSummary.broadcastInterval = response.data.summary.broadcast_interval;
                this.serviceUsageSummary.fileSize = response.data.summary.file_size;
                this.serviceUsageSummary.syndication_interval = response.data.summary.syndication_interval;
                this.loadSummary = true;
            }).catch((error) => {
                this.loadSummary = true;
            });
        },
        loadServiceUsages(serviceUsageApi) {
            this.serviceUsages.load = false;
            axios.get(serviceUsageApi).then((response) => {
                this.serviceUsages = response.data;
                this.serviceUsages.load = true;
            });
        },
        changeOrder(order) {
            const newOrder = order.match(/^(.*)_(asc|desc)$/);
            const curOrder = this.list_conditions.order.match(/(.*)_(asc|desc)$/);
            if (newOrder.length < 3) {
                return;
            }
            if (curOrder !== null && curOrder.length > 2 && newOrder[1] === curOrder[1]) {
                newOrder[2] = (curOrder[2] === 'asc') ? 'desc' : 'asc';
            }
            this.list_conditions.order = `${newOrder[1]}_${newOrder[2]}`;
            this.list_conditions.page = 1;
            this.loadServiceUsagesSummary();
            this.loadServiceUsages(this.serviceUsageApi);
        },
        changeConditions() {
            this.list_conditions.page = 1;
            this.loadServiceUsages(this.serviceUsageApi);
            this.loadChannels(this.serviceUsageApi);
        },
    },
    computed: {
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        broadcastApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/broadcasts/${this.selectedBroadcast}`;
        },
        serviceUsageSummaryApi() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/service_usage_summary`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}`;

            return apiLoc;
        },
        serviceUsageApi() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/service_usages`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&order=${this.list_conditions.order}`;

            return apiLoc;
        },
        getExportUrl() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/export_service_usage`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&order=${this.list_conditions.order}`;

            return apiLoc;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        includeTrashedChannel(newValue) {
            this.selectize_channels.onSearchChange($('#select_channel').val());
        },
    },
};
</script>
